import { Button } from "@tql/ui-components-react/tql/buttons";
import { truck_01 } from "@tql/ui-components-react/untitled/icons";

type AddCarrierProps = {
	adHocCarrierExists: boolean;
	addBlankCarrier: () => void;
	isInternal: boolean;
};

export const AddCarrier = ({
	adHocCarrierExists,
	addBlankCarrier,
	isInternal,
}: Readonly<AddCarrierProps>) => {
	if (!isInternal) return null;

	return (
		<div>
			<Button
				disabled={adHocCarrierExists}
				onClick={() => addBlankCarrier()}
				svgIcon={truck_01}
				variant={"tertiary"}
			>
				Add Carrier
			</Button>
		</div>
	);
};
